import { defineStore } from 'pinia';
export const useAuthStore = defineStore('__hero_mall_auth__', {
  state: function () {
    return {
      verifyAuthVisible: false,
      isShowMoreDrawer: false,
      formData: {},
      verifyRole: {},
      // 当前角色小号列表
      subList: [],
      // 当前小号
      currentSub: {},
      verifyRoleList: [],
      payTypeList: [],
      hPayTypeList: [],
      currentPayType: 0,
      // 支付方式的支付折扣 100等于没有折扣
      currentPayRate: 100,
      isChecked: false
    };
  },
  getters: {
    // 小号列表大于一条，显示切换按钮
    visibleSwitchSubBtn: function (state) {
      return state.subList.length > 1;
    },
    //   获取当前小号列表
    currentSubItem: function (state) {
      return state.subList.find(function (item) {
        return item.cpUid === state.verifyRole.cpUid;
      });
    }
  },
  actions: {
    setAuthVisible(verifyAuthVisible) {
      this.verifyAuthVisible = verifyAuthVisible;
    },
    setIsShowMoreDrawer(visible) {
      this.isShowMoreDrawer = visible;
    },
    setVerifyRole(data) {
      this.verifyRole = data;
    },
    setFormData(data) {
      this.formData = data;
    }
  }
});